module.exports = __webpack_public_path__ + "img/website-development.fb6ba0a6.png";